<template>
  <modal :showModal="showModal" id="modal-payout" @close="close">
    <template slot="modal-header">
      <h5 class="bold">Wypłać wynagrodzenie</h5>
    </template>

    <template slot="modal-body">
      <div class="payout-info">
        <p v-if="!data.tranche.token">
          Gratulujemy! Suma środków na Twoim koncie partnerskim osiągnęła próg wypłaty.
          Przejdź dalej, aby uzyskać niezbędne dane do zlecenia przelewu.
        </p>
        <transition name="slide-fade" mode="in-out">
          <p v-if="data.tranche.token">
            Aby wypłacić wynagrodzenie, wypełnij fakturę VAT (dla firm) lub rachunek (dla os. fizycznych)
            na podstawie poniższych informacji
            <span class='bold'>i prześlij na adres
              <a :href="`mailto:faktury@punkta.pl?subject=Transza nr: ${data.tranche.token}`">faktury@punkta.pl</a>
            </span>
          </p>
        </transition>
      </div>

      <div class="saldo">
        <stats-indicator icon="mfind-icon-wallet"
          :stats="trancheAmount() | currency">
          <template slot="header">
            <h6>Kwota wynagrodzenia</h6>
          </template>
        </stats-indicator>
      </div>

      <transition name="slide-fade" mode="in-out">
        <div class="second-page" v-if="data.tranche.token">
          <div class="line">
            <div class="inside-line">
              Dane do wysłania
            </div>
          </div>
          <invoice-details :token="data.tranche.token" />
        </div>
      </transition>
      <div class="line"></div>
    </template>

    <template slot="modal-footer">
      <button class="btn btn-large btn-first" @click="payout()" v-if="!data.tranche.token">
        <i class="mfind-icon-money"></i>
        Wypłać
      </button>
      <button class="btn btn-large" @click="close()" v-bind:class="{ 'btn-secondary': !data.tranche.token }">
        <i class="mfind-icon-back"></i>
        Zamknij
      </button>

      <transition name="slide-fade" mode="in-out">
        <div v-if="data.errors" class="error center-align validation-errors">
          <span class="red-text" v-if="data.errors['message']">{{ data.errors['message'].join(', ') }}</span>
          <span class="red-text" v-else>Coś poszło nie tak, skontaktuj się z nami.</span>
        </div>
      </transition>

      <p class="email-info" v-if="data.tranche.token">
        Dane zostały wysłane na Twój adres e-mail
      </p>
    </template>

    <template slot="loader">
      <Loader :loading="this.data.loading"/>
    </template>
  </modal>
</template>

<script>
import StatsIndicator from '@/components/statsIndicator'
import InvoiceDetails from '@/components/invoiceDetails'
import Loader from '@/components/loader'
import Modal from '@/components/modal'
export default {
  props: ['saldo', 'showModal'],
  components: { StatsIndicator, Loader, Modal, InvoiceDetails },
  data () {
    return {
      data: {
        loading: false,
        tranche: {
          token: false,
          amount: false
        },
        errors: false
      }
    }
  },
  methods: {
    close: function () {
      this.$emit('close')
    },
    trancheAmount: function () {
      return (this.data.tranche.amount) ? this.data.tranche.amount : this.saldo
    },
    payout: function () {
      this.data.errors = false
      this.data.loading = true
      this.$store.dispatch('generateTranche')
        .then(
          response => {
            if (response.code === 200) {
              this.data.tranche.amount = response.data.invoice_amount
              this.data.tranche.token = response.data.invoice_token
              this.data.loading = false
            }
          },
          errorResponse => {
            this.data.errors = errorResponse.errors
            this.data.loading = false
          }
        )
    }
  },
  mounted: function () {
    document.addEventListener('keydown', (e) => {
      if (this.showModal && e.keyCode === 27) {
        this.close()
      }
    })
  }
}
</script>

<style lang="scss" src="./modalPayout.scss"></style>



// WEBPACK FOOTER //
// modalPayout.vue?06d3ed92